import React from 'react';

const h3Style = {
  fontSize: '1.05rem',
  fontWeight: 700,
  color: 'var(--ink-700)',
  marginTop: 'var(--sp-6)',
  marginBottom: 'var(--sp-2)',
  letterSpacing: '-0.005em',
};
const pStyle = { color: 'var(--ink-500)', margin: '0 0 var(--sp-3)', lineHeight: 1.65 };
const ulStyle = { color: 'var(--ink-500)', margin: '0 0 var(--sp-3)', paddingLeft: 22, lineHeight: 1.65 };

function PrivacyPolicy() {
  return (
    <div style={{ color: 'var(--ink-700)', fontSize: 'var(--fs-body)' }}>
      <span className="cp-eyebrow">Legal</span>
      <h2 style={{ fontSize: 'var(--fs-h2)', fontWeight: 700, color: 'var(--ink-700)', margin: 'var(--sp-3) 0 var(--sp-2)', letterSpacing: '-0.015em' }}>
        Privacy Policy
      </h2>
      <p style={{ color: 'var(--ink-400)', fontSize: 'var(--fs-sm)', margin: '0 0 var(--sp-6)' }}>
        <strong>Effective:</strong> 1 July 2025
      </p>

      <p style={pStyle}>
        <strong>CoPlaid</strong> ("we", "us", or "our") is committed to protecting your privacy. This
        Privacy Policy explains how we collect, use, disclose, and safeguard your information when you
        use our software and services ("Services").
      </p>

      <h3 style={h3Style}>1. Information We Collect</h3>
      <ul style={ulStyle}>
        <li><strong>Personal Information:</strong> Name, email address, phone number, company name, and other information you provide when registering or using our Services.</li>
        <li><strong>Usage Data:</strong> Information about how you access and use our Services, including IP address, browser type, device information, and usage patterns.</li>
        <li><strong>Cookies &amp; Tracking:</strong> We use cookies and similar tracking technologies to enhance your experience and analyze usage.</li>
      </ul>

      <h3 style={h3Style}>2. How We Use Your Information</h3>
      <ul style={ulStyle}>
        <li>Provide, operate, and maintain our Services</li>
        <li>Improve, personalize, and expand our Services</li>
        <li>Communicate with you, including customer support and updates</li>
        <li>Process transactions and manage your account</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h3 style={h3Style}>3. How We Share Your Information</h3>
      <ul style={ulStyle}>
        <li>We do <strong>not</strong> sell your personal information.</li>
        <li>We may share information with service providers who help us operate our business (e.g., hosting, analytics, customer support).</li>
        <li>We may share information with legal authorities if required by law or to protect our rights.</li>
        <li>Other parties with your consent.</li>
      </ul>

      <h3 style={h3Style}>4. Data Security</h3>
      <p style={pStyle}>
        We implement reasonable security measures to protect your information. However, no method of
        transmission over the Internet or electronic storage is 100% secure.
      </p>

      <h3 style={h3Style}>5. Your Choices</h3>
      <p style={pStyle}>
        You may update, correct, or delete your account information at any time. You can also opt out
        of marketing communications.
      </p>

      <h3 style={h3Style}>6. Children's Privacy</h3>
      <p style={pStyle}>
        Our Services are not intended for children under 13. We do not knowingly collect personal
        information from children.
      </p>

      <h3 style={h3Style}>7. Changes to This Policy</h3>
      <p style={pStyle}>
        We may update this Privacy Policy from time to time. We will notify you of any changes by
        posting the new policy on this page.
      </p>

      <h3 style={h3Style}>8. Contact Us</h3>
      <p style={pStyle}>
        If you have any questions about this Privacy Policy, please contact us at{' '}
        <a href="mailto:support@coplaid.ai" style={{ color: 'var(--brand-600)', fontWeight: 500 }}>
          support@coplaid.ai
        </a>.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
